import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Facebook, ShieldCheck, LayoutDashboard } from 'lucide-react';
import { ADMIN } from '@/lib/adminApi';

export default function TopBar() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Best-effort: silently probe the admin session so we can show "Dashboard" link if logged in.
    ADMIN.me().then(() => setIsAdmin(true)).catch(() => setIsAdmin(false));
  }, []);

  return (
    <div className="bg-[#0f172a] text-white py-2">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm">
          <div className="flex items-center gap-2">
            <span className="text-slate-400">Licensed & Insured</span>
            <span className="hidden sm:inline text-slate-600">|</span>
            <span className="text-slate-400">Serving Central Florida</span>
          </div>
          <div className="flex items-center gap-3 sm:gap-4">
            <a href="tel:+14077850642" className="flex items-center gap-2 hover:text-slate-300 transition-colors">
              <Phone className="h-4 w-4" />
              <span className="font-semibold">Call Us Anytime: (407) 785-0642</span>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-slate-300 transition-colors" aria-label="Facebook">
              <Facebook className="h-4 w-4" />
            </a>
            <span className="hidden sm:inline text-slate-700">|</span>
            {isAdmin ? (
              <Link
                to="/admin"
                className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-slate-200 hover:text-white transition-colors px-2 py-1 rounded-md hover:bg-white/10"
                data-testid="topbar-dashboard-link"
              >
                <LayoutDashboard className="h-3.5 w-3.5" />
                <span className="font-semibold">Dashboard</span>
              </Link>
            ) : (
              <Link
                to="/admin/login"
                className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-slate-300 hover:text-white transition-colors px-2 py-1 rounded-md hover:bg-white/10"
                data-testid="topbar-admin-login"
              >
                <ShieldCheck className="h-3.5 w-3.5" />
                <span className="font-semibold">Owner Login</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
